import { getCountryNameList } from './countryAndRegionUtils'

const countryList = getCountryNameList()
export const countries = countryList
